import { CITAS } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null,
    listado_horarios_cita: [],
    listado_contrataciones: [],
    listado_locatarios: [],
    ventana_filtros: false,
    filtros: null
};

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch(type) {
        case CITAS.BUSCAR:
            let citas_listar = payload;

            citas_listar.sort(function(a, b) {
                if(a.fecha_inicio > b.fecha_inicio) return -1;
                if(a.fecha_inicio < b.fecha_inicio) return 1;
                return 0;
            });

            return {
                ...state,
                listado: citas_listar
            };

        case CITAS.BUSCAR_HORARIOS:
            return {
                ...state,
                listado_horarios_cita: payload
            };

        case CITAS.BUSCAR_CONTRATACIONES:
            return {
                ...state,
                listado_contrataciones: payload
            };

        case CITAS.BUSCAR_LOCATARIOS:
            return {
                ...state,
                listado_locatarios: payload
            };

        case CITAS.AGREGAR:
            let citas_agregar = [...state.listado, ...payload];

            citas_agregar.sort(function(a, b) {
                if(a.fecha_inicio > b.fecha_inicio) return -1;
                if(a.fecha_inicio < b.fecha_inicio) return 1;
                return 0;
            });

            return {
                ...state,
                listado: citas_agregar
            };

        case CITAS.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case CITAS.EDITAR:
            let citas_editar = state.listado.map(cita => cita._id === payload._id ? payload : cita);

            citas_editar.sort(function(a, b) {
                if(a.fecha_inicio > b.fecha_inicio) return -1;
                if(a.fecha_inicio < b.fecha_inicio) return 1;
                return 0;
            });

            return {
                ...state,
                listado: citas_editar
            };

        case CITAS.ELIMINAR:
            let citas_eliminar = state.listado;

            for(var i = 0; i < payload.length; i++) {
                citas_eliminar = citas_eliminar.filter(cita => cita._id !== payload[i]);
            }

            return {
                ...state,
                listado: citas_eliminar
            };

        case CITAS.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        default:
            return state;
    }
}
